import {
  REQUEST_SHOPS_SUCCESS,
  REQUEST_SHOPS_FAILURE,
  REQUEST_PRODUCT_SHOPS_SUCCESS,
  REQUEST_SHOP_DETAILS_SUCCESS,
  DELETE_SHOP_SUCCESS,
  DELETE_SHOP_FAILURE,
  ADD_SHOP_SUCCESS,
  UPDATE_SHOP_SUCCESS,
} from "../../constants/actionTypes";

const INITIAL_STATE = {
  shops: [],
  shopsToPush: [],
};

const getShopFromPayload = (payload) =>
  payload?.data?.shop || payload?.data || payload?.shop || null;

const upsertShop = (shops = [], shop) => {
  if (!shop?.id) return shops;
  const exists = shops.some((item) => String(item?.id) === String(shop.id));
  if (!exists) return [...shops, shop];
  return shops.map((item) =>
    String(item?.id) === String(shop.id) ? { ...item, ...shop } : item
  );
};

export default function shops(state = INITIAL_STATE, action) {
  switch (action.type) {
    case REQUEST_SHOPS_SUCCESS:
      return {
        ...state,
        shops: (action?.payload?.data?.shops || []).sort(
          (a, b) => a?.createdAt?._seconds - b?.createdAt?._seconds
        ),
      };

    case REQUEST_SHOPS_FAILURE:
      return { ...state, error: "Record not found" };

    case REQUEST_PRODUCT_SHOPS_SUCCESS:
      return { ...state, shopsToPush: action?.payload?.data?.shops || [] };

    case REQUEST_SHOP_DETAILS_SUCCESS: {
      const shop = getShopFromPayload(action?.payload);
      return {
        ...state,
        shops: upsertShop(state.shops, shop),
        shopsToPush: upsertShop(state.shopsToPush, shop),
      };
    }

    case ADD_SHOP_SUCCESS: {
      const shop = getShopFromPayload(action?.payload);
      return {
        ...state,
        shops: upsertShop(state.shops, shop),
        shopsToPush: upsertShop(state.shopsToPush, shop),
      };
    }

    case UPDATE_SHOP_SUCCESS: {
      const shop = getShopFromPayload(action?.payload);
      return {
        ...state,
        shops: upsertShop(state.shops, shop),
        shopsToPush: upsertShop(state.shopsToPush, shop),
      };
    }

    case DELETE_SHOP_SUCCESS:
      const afterDelete = state?.shops.filter(
        (shop) => shop?.id !== action?.payload?.id
      );

      return {
        ...state,
        shops: afterDelete,
        shopsToPush: state?.shopsToPush.filter(
          (shop) => shop?.id !== action?.payload?.id
        ),
      };

    case DELETE_SHOP_FAILURE:
      return { ...state, error: "Record not found" };

    default:
      return state;
  }
}
